import React from 'react';

export const FormSubmitFooter = props => {
  const { onReset, isFormValid, buttonStyle, submitButtonLabel, systemMessages, resetHidden, disabled } = props;

  return (
    <div className="cu-ui-form-submit-footer">
      {
        !resetHidden &&
        <button
        type='reset'
        className='cu-ui-button cu-ui-default'
        onClick={onReset}
        disabled={disabled}
        >
          { systemMessages.reset }
        </button>
      }

      <button
        type='submit'
        className="cu-ui-button cu-ui-primary"
        disabled={!isFormValid}
        style={buttonStyle}
      >
        { submitButtonLabel }
      </button>
    </div>
  );
}
